import axios from 'axios';
import Vue from 'vue'

export default {

    getUserTablePrivilege (campaignId) {
        return axios.get('/api/table-privilege/list', { params: { campaignId:campaignId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    updateUserTablePrivilege (data) {
        return axios.post('/api/table-privilege/update', data)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
   
}